import { removeRowsByCondition } from "./removeRows";

export const skipCondition = (
  worksheet,
  outputSheet,
  rules,
  rule,
  fileSettings,
  inputColumns,
  outputColumns,
) => {
  removeRowsByCondition(worksheet, rule);
};
